import { useEffect } from "react";

function useAppTitle(appTitle: string) {
  useEffect(() => {
    const defaultitle = "IWF Config Admin Tool (ICAT) by AT&T";
    document.title = appTitle;
    return () => {
      document.title = defaultitle;
    };
  });
}

export default useAppTitle;
